import {Journals} from './Journals';
export default Journals;
